<template>
  <v-snackbar
    :model-value="modelValue"
    location="bottom right"
    :timeout="-1"
    transition="slide-y-reverse-transition"
    class="app-warning-snackbar"
    :data-locator="dataLocator"
    :style="{ '--warning-width': `${width}px` }"
  >
    <div class="d-flex justify-space-between align-center column-gap-4 mb-4">
      <p class="app-warning-snackbar__title mb-0" :style="{ color: titleColor }">
        <slot name="title">{{ title }}</slot>
      </p>
      <app-button
        type="icon"
        size="x-small"
        class="app-warning-snackbar__close"
        data-locator="close-button"
        @click="onClose"
      >
        <app-material-icon name="close" />
      </app-button>
    </div>
    <p class="app-warning-snackbar__text mb-4" :style="{ color: textColor }">
      <slot name="text">{{ text }}</slot>
    </p>
    <v-checkbox
      v-model="dontShowAgain"
      :label="effectiveCheckboxLabel"
      hide-details
      density="compact"
      data-locator="dont-show-again-checkbox"
      class="app-warning-snackbar__checkbox"
      :style="{ '--checkbox-color': checkboxColor }"
      @update:model-value="onDontShowAgainChange"
    />
  </v-snackbar>
</template>

<script>
export default {
  name: 'AppWarningSnackbar',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    checkboxLabel: {
      type: String,
      default: null
    },
    titleColor: {
      type: String,
      default: 'rgb(var(--v-theme-text-primary))'
    },
    textColor: {
      type: String,
      default: 'rgb(var(--v-theme-text-secondary))'
    },
    checkboxColor: {
      type: String,
      default: 'rgb(var(--v-theme-text-primary))'
    },
    dataLocator: {
      type: String,
      default: 'app-warning-snackbar'
    },
    width: {
      type: Number,
      default: 450
    },
  },
  emits: ['update:modelValue', 'dont-show-again'],
  data () {
    return {
      dontShowAgain: false,
    }
  },
  computed: {
    effectiveCheckboxLabel () {
      return this.checkboxLabel ?? this.$t('common.dontShowAgain')
    },
  },
  watch: {
    modelValue (value) {
      if (value) {
        this.dontShowAgain = false
      }
    },
  },
  methods: {
    onClose () {
      this.$emit('update:modelValue', false)
    },
    onDontShowAgainChange (value) {
      if (value) {
        this.$emit('dont-show-again')
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/box-shadow-tokens";

.app-warning-snackbar {
  :deep(.v-snackbar__wrapper) {
    position: fixed;
    right: 16px;
    bottom: 16px;
    width: var(--warning-width, 450px);
    max-width: var(--warning-width, 450px);
    min-width: var(--warning-width, 450px);
    background-color: rgb(var(--v-theme-surface-primary));
    @include border-radius('border-radius-4');
    @include box-shadow('box-shadow-medium');
    border: get-border();
  }

  :deep(.v-snackbar__content) {
    color: rgb(var(--v-theme-text-secondary));
    padding: 20px;
  }

  &__title {
    font-weight: 500;
    font-size: 16px;
  }

  &__text {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
